var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "mb-2", attrs: { "no-body": "" } },
    [
      _c(
        "b-card-header",
        [
          _c(
            "b-row",
            { attrs: { "align-v": "center" } },
            [
              _c("b-col", { staticClass: "mr-auto", attrs: { cols: "auto" } }, [
                _c("h5", {}, [_vm._v("Виды услуг исполнителей")])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.isDisabled
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.onAdd()
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "plus" }
                      }),
                      _vm._v("\n          Добавить\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        ref: "location_work_services",
        staticClass: "mb-0",
        attrs: {
          id: "location-work-services",
          striped: "",
          small: "",
          "thead-class": "top-fixed-thead thead-light",
          "table-class": "text-small",
          responsive: "",
          "show-empty": "",
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.fields,
          "current-page": _vm.currentPage,
          "per-page": _vm.perPage,
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          "sort-compare": _vm.sortCompare,
          "empty-text": _vm.$t("message.common.emptyTable"),
          "no-provider-filtering": "",
          "no-provider-paging": "",
          "no-provider-sorting": ""
        },
        on: {
          "update:busy": function($event) {
            _vm.isBusy = $event
          },
          "update:sortBy": function($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function($event) {
            _vm.sortDesc = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "cell(work_service)",
            fn: function(row) {
              return [
                _c("work-service-select", {
                  ref: "work_service_select",
                  attrs: {
                    id: "work-service-select",
                    "is-disabled": _vm.isDisabled,
                    id: row.item.work_service_id
                  },
                  on: {
                    onSelect: function($event) {
                      return _vm.onSelectWorkService($event, row)
                    }
                  }
                })
              ]
            }
          },
          {
            key: "cell(price)",
            fn: function(row) {
              return [
                _c("b-form-input", {
                  attrs: {
                    id: "input-price",
                    size: "sm",
                    disabled: _vm.isDisabled,
                    autocomplete: "off",
                    type: "number"
                  },
                  model: {
                    value: row.item.price,
                    callback: function($$v) {
                      _vm.$set(row.item, "price", _vm._n($$v))
                    },
                    expression: "row.item.price"
                  }
                })
              ]
            }
          },
          {
            key: "cell(unit)",
            fn: function(row) {
              return [
                _c("unit-select", {
                  ref: "unit_select",
                  attrs: {
                    id: "input-unit",
                    "is-disabled": _vm.isDisabled,
                    "initial-unit": row.item.unit_code,
                    "is-short": ""
                  },
                  on: {
                    selectUnit: function($event) {
                      return _vm.onSelectUnit($event, row)
                    }
                  }
                })
              ]
            }
          },
          {
            key: "cell(action)",
            fn: function(row) {
              return [
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "danger",
                      size: "sm",
                      disabled: _vm.isDisabled
                    },
                    on: {
                      click: function($event) {
                        return _vm.onRemove(row)
                      }
                    }
                  },
                  [_c("font-awesome-icon", { attrs: { icon: "trash" } })],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "b-card-footer",
        { attrs: { "footer-bg-variant": "light" } },
        [
          _c(
            "b-row",
            { attrs: { "align-h": "between", "align-v": "center" } },
            [
              _c("b-col", { staticClass: "mr-auto", attrs: { cols: "auto" } }, [
                _vm._v("\n        Всего записей: "),
                _c("b", [_vm._v(_vm._s(_vm.items.length))])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      id: "location-work-services-pagination",
                      pills: "",
                      "total-rows": _vm.items.length,
                      "per-page": _vm.perPage
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b2d48c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b2d48c5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationWorkServices.vue
// module id = null
// module chunks = 